module.exports = __webpack_public_path__ + "img/hevosreitti_virma.c12782fa.svg";